<script setup>
import { nextTick, watch } from 'vue';
import { Handle, Position, useVueFlow } from '@vue-flow/core';
import { useI18n } from 'vue-i18n';
import BaseNode from './BaseNode.vue';

const props = defineProps({
  id: { type: String, required: true },
  data: { type: Object, required: true },
  selected: { type: Boolean, default: false },
  icon: { type: String, required: true },
  typeLabel: { type: String, required: true },
  accentClass: { type: String, required: true },
});

const { t } = useI18n();
const { updateNodeInternals } = useVueFlow();

// Branch handles are part of the node's DOM; Vue Flow must re-measure them
// whenever branches are added or removed.
watch(
  () => props.data.branches?.length,
  () => nextTick(() => updateNodeInternals([props.id]))
);
</script>

<template>
  <BaseNode
    :node-id="props.id"
    :selected="selected"
    :icon="icon"
    :type-label="typeLabel"
    :node-label="data.label"
    :accent-class="accentClass"
    :has-source="false"
  >
    <ul class="mb-0 flex list-none flex-col gap-2 border-t border-n-weak p-3">
      <li
        v-for="branch in data.branches"
        :key="branch.id"
        class="relative rounded-md bg-n-alpha-black2 px-3 py-2 text-sm text-n-slate-12"
      >
        <span class="block whitespace-pre-wrap break-words ltr:pr-2 rtl:pl-2">
          {{ branch.label || t('SOPS.BUILDER.PANEL.BRANCH_PLACEHOLDER') }}
        </span>
        <Handle :id="branch.id" type="source" :position="Position.Right" />
      </li>
    </ul>
  </BaseNode>
</template>
